<template>
	<div id="finance-file">
		<van-pull-refresh v-model="isRefresh" @refresh="onRefresh" class="content">
			<van-list v-model="isLoading" :finished="isFinished" @load="onLoad">
				<div v-for="item in list" :key="item.id">
					<div class="item">
						<van-row type="flex" justify="space-between">
							<div class="name" @click="doCopy(item.url)">{{ item.name }}</div>
							<van-icon name="down" color="#1592E6" size="1.5625rem" @click="download(item.url)" />
						</van-row>
					</div>
					<van-divider class="divider" />
				</div>
			</van-list>
		</van-pull-refresh>

		<div id="btn-container">
			<van-button id="btn-apply" type="info" :to="{ path: '/finance/applying' }" :disabled="token == ''">我要融资</van-button>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Toast } from 'vant'

export default {
	props: ['tabId'],
	data() {
		return {
			list: [],
			isRefresh: false,
			isLoading: false,
			isFinished: false,
			isOpen: false,
			scrUrl: '',
		}
	},

	computed: {
		...mapGetters(['token', 'userId', 'communityId']),
	},
	watch: {
		communityId() {
			this.onLoad()
		},
		tabId() {
			this.onLoad()
		},
	},

	methods: {
		clickHide() {
			this.isOpen = false
		},
		openPDF(item) {
			if (item.url.substring(item.url.length - 3) === 'pdf') {
				this.isOpen = !this.isOpen
				this.scrUrl = item.url
			} else {
				Toast('只能打开pdf格式文件')
			}
		},
		onRefresh() {
			this.list = []
			this.onLoad()
			this.$toast('刷新成功')
			this.isRefresh = false
		},

		onLoad() {
			if (this.tabId != 2) return
			this.list = []
			this.vaxios.get(
				`${this.vaxios.host}/open/api/v1/investment-finances/status/published`,
				{
					communityId: this.communityId,
				},
				(res) => {
					this.isLoading = false
					this.isFinished = true
					if (res === -1 || !res.data) return
					let attachs = res.data.attachs

					attachs.forEach((item) => {
						if (item.attach_type == 2) {
							this.list.push({
								id: item.id,
								name: item.attach_name,
								url: item.attach_url,
							})
						}
					})
				},
				function(err) {
					console.log(err)
				}
			)
		},
		download(url) {
			window.location.href = url
		},
		doCopy(res) {
			this.$copyText(res).then(
				() => {
					Toast.success('下载地址已复制到剪贴板')
				},
				() => {
					Toast.fail('下载地址复制失败')
				}
			)
		},
	},
}
</script>

<style scoped>
#finance-file {
	height: 100%;
	background-color: #f5f5f5;
	padding-top: 0.75rem;
}

.item {
	padding: 0.78125rem 1rem 0.8125rem 1rem;
	background-color: #ffffff;
}

.item .name {
	color: #272727;
	font-size: 0.875rem;
	width: 90%;
}

.divider {
	margin: 0;
}

#btn-container {
	position: fixed;
	margin-top: 3.3125rem;
	bottom: 0;
	width: 100%;
	z-index: 99;
	background: white;
	height: 80px;
	text-align: center;
	display: flex;
	align-items: center;
	border-top: 0.5px solid lightgray;
}

#btn-apply {
	width: 91.47%;
	font-size: 1.125rem;
	height: 2.75rem;
	padding: 0;
	margin: 0 auto;
}

.pdfClass {
	background-color: white;
	position: absolute;
	z-index: 999;
	top: 10%;
	width: 100%;
	height: 100%;
	left: 0;
	right: 0;
}

.content {
	margin-bottom: 100px;
}
</style>
